import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';
import BeeInput from '@/components/BeeInput.vue';
import { StatusDelivery } from '@/models/Order';
let DeliveryFrom = class DeliveryFrom extends Vue {
    constructor() {
        super(...arguments);
        this.address = this.$store.state.address;
        this.phone = this.$store.state.order.phone;
        this.extPhone = '';
        this.formErrors = {
            street: false,
            intNumber: false,
            extNumber: false,
            postal: false,
            region: false,
            references: false,
            phone: false,
        };
    }
    async saveForm() {
        if (!this.validForm())
            return;
        this.$store.state.order.address = this.address;
        this.$store.state.order.phone = this.phone;
        this.$store.state.order.phoneExt = this.extPhone;
        this.$store.state.order.statusDelivery = StatusDelivery.SUMMARY;
        this.$analytics.logEvent('add_shipping_info', {
            currency: this.$store.state.order.currency,
            value: this.$store.state.order.subtotal + this.$store.state.order.deliveryCost,
            items: this.$store.state.order.items.map(item => ({
                item_id: item.id,
                item_name: item.name,
                quantity: item.quantity,
                price: Number(item.price),
                item_category: item.category,
                item_category2: item.subcategory,
                item_brand: this.$store.state.menu.name,
                affiliation: this.$store.state.typeOrder
            }))
        });
        this.$router.push('/summary');
    }
    validForm() {
        this.formErrors = { street: false,
            intNumber: false,
            extNumber: false,
            postal: false,
            region: false,
            references: false,
            phone: false,
        };
        if (!this.address.street)
            this.formErrors.street = true;
        if (!this.address.extNumber)
            this.formErrors.extNumber = true;
        if (!this.address.postal)
            this.formErrors.postal = true;
        if (!this.address.region)
            this.formErrors.region = true;
        if (!this.address.references)
            this.formErrors.references = true;
        if (!this.phone)
            this.formErrors.phone = true;
        for (const error of Object.values(this.formErrors)) {
            if (error == true) {
                return false;
            }
        }
        return true;
    }
};
DeliveryFrom = __decorate([
    Component({
        components: {
            BeeInput,
            BlankLayout,
            CommonHeader
        }
    })
], DeliveryFrom);
export default DeliveryFrom;
